import { useContext } from "react";
import { useEffect, useState } from "react";
import StoreContext from "../Store/code-context";

// const PREFIX = "rahul-store-";

export default function useStore(key, initialValue) {
  const storeCtx = useContext(StoreContext);
  const prefixedKey = storeCtx.Prefix + key;

  const [value, setValue] = useState(() => {
    const jsonData = localStorage.getItem(prefixedKey);
    if (jsonData != null) return JSON.parse(jsonData);

    if (typeof initialValue === "function") {
      return initialValue();
    } else {
      return initialValue;
    }
  });

  useEffect(() => {
    localStorage.setItem(prefixedKey, JSON.stringify(value));
  }, [prefixedKey, value]);

  return [value, setValue];
}
